import React, { useState } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

import Button from '../global/button';
import ButtonLink from '../global/button-link';
import Section from '../global/section';
import moment from 'moment';

const EventsStyle = styled.div`
	text-align: center;

	h2 {
		color: ${(p) => p.theme.color.teal};
	}
	span {
		color: ${(p) => p.theme.color.green};
	}

	&.dark {
		section {
			background-color: ${(p) => p.theme.color.dark};
			background-image: url(/img/left-right-blob.svg);
			background-position: right top;
			background-size: 500px;
			background-repeat: no-repeat;
		}
		h2 {
			color: #fff;

			span {
				color: ${(p) => p.theme.color.teal};
			}
		}
	}

	h2 {
		font-size: 2.5rem;
		text-align: left;
		margin-bottom: 5rem;
		padding: 0 1rem;
	}
	button {
		margin: 4rem auto 0;
	}
	.no-events {
		h3 {
			color: ${(p) => p.theme.color.teal};
			text-align: left;

			span {
				text-transform: lowercase;
				color: currentColor;
			}
		}
	}
	.flex {
		padding: 0 1rem;
		display: flex;
		flex-wrap: wrap;
		text-align: left;

		&.more {
			margin-top: 2rem;
			.col {
				margin-top: 5rem;
			}
		}

		.col {
			background-color: ${(p) => p.theme.color.purple};
			border-radius: 20px;
			margin-right: 1.5rem;
			width: calc(33% - 1rem);
			&:nth-child(3n) {
				margin-right: 0;
			}

			.img-wrap {
				margin: 0 auto;

				img {
					width: calc(100% - 4rem);
					max-width: 400px;
					margin: 0 auto;
					border: 4px solid white;
					z-index: 10;
					box-shadow: 0 0 16px 8px rgba(0, 0, 0, 0.25);
					position: relative;
					top: -2rem;
				}
			}
			.content-wrap {
				margin-top: -2rem;

				padding: 2rem;
				z-index: 5;
				color: #fff;

				h3 {
					font-size: 2rem;
					margin-bottom: 2rem;
				}
				h4 {
					font-size: 1.4rem;
					font-weight: 700;
					margin-bottom: 1rem;
					line-height: 1.2;
				}
				p {
					font-size: 1.125rem;
					margin-bottom: 1rem;
				}
			}
			a {
				margin-top: 1rem;
			}
		}
	}
	@media all and (max-width: 1050px) {
		h2 {
			margin-bottom: 3rem;
		}
		.flex,
		.flex.more {
			flex-wrap: wrap;
			.col {
				width: calc(50% - 1.5rem);
				margin-right: 0;
				margin-bottom: 4rem;
				margin-top: 2rem;
				&:nth-child(2n) {
					margin-left: 1.5rem;
				}
			}
		}
		button {
			margin-top: 0;
			margin-bottom: 3rem;
		}
		section {
			padding: 6rem 0 3rem;
		}
	}
	@media all and (max-width: 768px) {
		.flex,
		.flex.more {
			.col {
				width: 100%;
				&:nth-child(2n) {
					margin-left: 0;
				}
				.img-wrap {
					max-width: 350px;
					width: 100%;
				}
			}
		}
	}
	@media all and (max-width: 550px) {
		.flex {
			padding: 0;

			.col {
				.img-wrap {
					padding: 0;
					img {
						width: calc(100% - 2rem);
					}
				}
				.content-wrap {
					padding: 2rem 1rem 2rem;
					h3 {
						margin-bottom: 1.5rem;
					}
					h4 {
						margin: 1rem 0 1.5rem;
					}
				}
			}
		}
	}
`;

export default ({ events, title, bg }) => {
	const [showAll, setShowAll] = useState(false);

	const toggleMore = () => {
		setShowAll(!showAll);
	};

	return (
		<EventsStyle className={bg}>
			<Section bg="white">
				<h2>
					<span>></span> {title}
				</h2>
				{events.length ? (
					<div className="flex">
						{events.slice(0, 3).map((x, i) => (
							<div className="col" key={i}>
								<div className="img-wrap">
									<Link to={x.fields.slug}>
										<img src={x.poster} alt={x.title} />
									</Link>
								</div>
								<div className="content-wrap">
									<div>
										<h3>{x.title}</h3>
										<p>{x.excerpt}</p>
									</div>
									<div>
										<h4>
											{x.location} |
											<span> {moment(x.date).format('MMM DD, YYYY')}</span>
										</h4>
										<ButtonLink to={x.fields.slug} bg="teal">
											VIEW EVENT
										</ButtonLink>
									</div>
								</div>
							</div>
						))}
					</div>
				) : (
					<div className="no-events">
						<h3>
							There are currently no <span>{title}</span>. <br />
							Check back soon for updates!
						</h3>
					</div>
				)}
				{events.length > 3 && (
					<Button onClick={toggleMore} bg="purple">
						{showAll ? 'SHOW LESS' : 'SHOW MORE'}
					</Button>
				)}
				{showAll && (
					<div className="flex more">
						{events.slice(3).map((x, i) => (
							<div className="col" key={i}>
								<div className="img-wrap">
									<img src={x.poster} alt={x.title} />
								</div>
								<div className="content-wrap">
									<div>
										<h3>{x.title}</h3>
										<p>{x.excerpt}</p>
									</div>
									<div>
										<h4>
											{x.location} |{' '}
											<span>{moment(x.date).format('MMM DD, YYYY')}</span>
										</h4>
										<ButtonLink to={x.fields.slug} bg="teal">
											VIEW EVENT
										</ButtonLink>
									</div>
								</div>
							</div>
						))}
					</div>
				)}
			</Section>
		</EventsStyle>
	);
};
